import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from '../router';
import raportIncasariPlati from "./modules/raportIncasariPlati"
import raportNecesarNumerar from "./modules/raportNecesarNumerar"
import registruDeCasa from "./modules/registruDeCasa"
import situatiiContabile from "./modules/situatiiContabile"
import raportIncasariCastiguri from "./modules/raportIncasariCastiguri"
import messages from "./modules/messages/messages"

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        token: localStorage.getItem('access_token') || null,
        apiUrl: process.env.VUE_APP_API_URL,
        judete: [],
        produse: [],
        managerGroups: [],
        managerCompanies: [],
        shops: [],
    },
    mutations: {
        setToken(state, token){
            state.token = token;
        },
        destroyToken(state){
            state.token = null;
        },
        setJudete(state, judete){
            Vue.set(state, 'judete', judete);
        },
        setProduse(state, produse){
            Vue.set(state, 'produse', produse);
        },
        setManagerGroups(state, managerGroups){
            Vue.set(state, 'managerGroups', managerGroups);
        },
        setManagerCompanies(state, managerCompanies){
            Vue.set(state, 'managerCompanies', managerCompanies);
        },
        setShops(state, shops){
            //state.shops = shops;
            Vue.set(state, 'shops', shops);
        }
    },
    getters: {
        getToken(state){
            return state.token;
        },
        loggedIn(state){
            return state.token !==  null;
        },
        getApiUrl(state){
            return state.apiUrl;
        },
        getJudete(state){
            return state.judete;
        },
        getProduse(state){
            return state.produse;
        },
        getManagerGroups(state){
            return state.managerGroups;
        },
        getManagerCompanies(state){
            return state.managerCompanies;
        },
        getShops(state){
            return state.shops;
        }
    },
  actions: {
    retriveToken(context, credentials){

        return new Promise((resolve, reject) => {
            axios.post(context.getters.getApiUrl + '/auth/tfa', {
                twoFactorCode: credentials.twoFactorCode,
                userName: credentials.userName,
                email: credentials.email
            })
            .then(response => {
                //console.log(response);
                let token = response.data.token;
                context.commit('setToken', token);
                localStorage.setItem('access_token', token);
                resolve(response);
            })
            .catch(error => {
                console.log('error: ' + error.response);
                reject(error);
            })
        });

    },
    destroyToken(context){
        if(context.rootGetters.loggedIn){
            return new Promise((resolve, reject) => {
                //todo stege tokenul si din backend
                context.commit('destroyToken');
                localStorage.removeItem('access_token');
                if(!context.getters.loggedIn){
                    resolve();
                }else{
                    reject();
                }
            })
        }
    },
    getJudete(context){
        if(context.rootGetters.loggedIn){
            axios({
                method: "get",
                url: context.getters.getApiUrl + '/managerInfo/getJudete',
                headers: { 
                    Authorization: 'Bearer ' + context.getters.getToken,
                    Accept: '*/*'
                }
            })
            .then(response => {
                context.commit('setJudete', response.data);
            })
            .catch(error => {
                console.log(error);
                if(error.response.status === 401){
                    //context.dispatch('destroyToken');
                    context.dispatch('destroyToken', null, { root: true })
                        .then(() => {
                            router.push({ name: 'login' });
                        })
                }
            })
        }
    },
    getProduse(context){
        if(context.rootGetters.loggedIn){
            axios({
                method: "get",
                url: context.getters.getApiUrl + '/managerInfo/getGames',
                headers: { 
                    Authorization: 'Bearer ' + context.getters.getToken,
                    Accept: '*/*'
                }
            })
            .then(response => {
                context.commit('setProduse', response.data);
            })
            .catch(error => {
                console.log(error);
                if(error.response.status === 401){
                    //context.dispatch('destroyToken');
                    context.dispatch('destroyToken', null, { root: true })
                        .then(() => {
                            router.push({ name: 'login' });
                        })
                }
            })
        }
    },
    getManagerGroups(context){
        if(context.rootGetters.loggedIn){
            axios({
                method: "get",
                url: context.getters.getApiUrl + '/managerInfo/getManagerGroups',
                headers: { 
                    Authorization: 'Bearer ' + context.getters.getToken,
                    Accept: '*/*'
                }
            })
            .then(response => {
                context.commit('setManagerGroups', response.data);
            })
            .catch(error => {
                console.log(error);
                if(error.response.status === 401){
                    //context.dispatch('destroyToken');
                    context.dispatch('destroyToken', null, { root: true })
                        .then(() => {
                            router.push({ name: 'login' });
                        })
                }
            })
        }
    },
    getManagerCompanies(context){
        if(context.rootGetters.loggedIn){
            axios({
                method: "get",
                url: context.getters.getApiUrl + '/managerInfo/getManagerCompanies',
                headers: {
                    Authorization: 'Bearer ' + context.getters.getToken,
                    Accept: '*/*'
                }
            })
            .then(response => {
                context.commit('setManagerCompanies', response.data);
            })
            .catch(error => {
                console.log(error);
                if(error.response.status === 401){
                    //context.dispatch('destroyToken');
                    context.dispatch('destroyToken', null, { root: true })
                        .then(() => {
                            router.push({ name: 'login' });
                        })
                }
            })
        }
    },
    getShops(context){
        if(context.rootGetters.loggedIn){
            axios({
                method: "get",
                url: context.rootGetters.getApiUrl + '/managerInfo/getShops',
                headers: {
                    Authorization: 'Bearer ' + context.rootGetters.getToken,
                    Accept: '*/*'
                }
            })
            .then(response => {
                console.log(response.data);
                context.commit('setShops', response.data);
            })
            .catch((error) => {

                if(error.response.status === 401){
                    //context.dispatch('destroyToken');
                    context.dispatch('destroyToken', null, { root: true })
                        .then(() => {
                            router.push({ name: 'login' });
                        });
                }
            })
        }
    }
  },
  modules: {
      raportIncasariPlati,
      raportIncasariCastiguri,
      raportNecesarNumerar,
      situatiiContabile,
      registruDeCasa,
      messages
  }
});
